const parse = (key: string): {signature?: string; key?: string} | null => {
  try { return JSON.parse(localStorage.getItem(key) ?? 'null'); } catch { return null; }
};
export const legacyCheckoutMessage = 'This browser has an older unfinished checkout. Ask station staff to recover it before placing the same order again.';
/** New retries are account-scoped. Never silently replace a pre-upgrade uncertain checkout. */
export function pendingCheckout(identity: string, channel: string, signature: string, requestedKey: string) {
  const storageKey = `tequisa-pending-checkout-${JSON.stringify([identity, channel])}`;
  const pending = parse(storageKey);
  const retry = pending?.signature === signature && typeof pending.key === 'string';
  if (!retry && parse(`tequisa-pending-checkout-${channel}`)?.signature === signature) throw new Error(legacyCheckoutMessage);
  return { storageKey, key: retry ? pending.key! : requestedKey, retry };
}
